import AtModal from './components/main'

export {
  AtModal
}
export default {
  install(Vue) {
    Vue.component('at-modal', AtModal)
  }
}



// WEBPACK FOOTER //
// ./src/packages/components/modal/index.js